export default __webpack_public_path__ + "assets/bfec6719233c38ee64ab08205e2ca1e7.webp";